import * as React from 'react';
import NovidadeService from '../../../services/NovidadesService';

export const ReorderPerguntasModel = (({
  tipos
}) => {

  const [tipo, setTipo] = React.useState(tipos[0]);
  const [dataType, setDataType] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      const response = await NovidadeService.getDataToOrder(tipo);
      setDataType(response?.data ?? []);
      setIsLoading(false);
    }
    getData();

  }, [tipo]);

  const updateOrder = (result) => {

    if (!result.destination) return;

    const items = Array.from(dataType);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setDataType(items);
  }

  const saveOrder = async () => {
    const valuesOrdered = dataType.map(({
      id,
      ordem,
      titulo,
      descricao,
      tipo: lolalType
    }) => {
      return {
        id,
        ordem,
        titulo,
        descricao,
        tipo: lolalType
      }
    })

    const response = await NovidadeService.order({ novidades: valuesOrdered });
    return response
  }

  return {
    tipo,
    setTipo,
    dataType,
    updateOrder,
    saveOrder,
    isLoading,
  }

})